var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1806 4.61541L22.068 16.2496C23.0546 17.9161 21.8534 20.0231 19.9167 20.0231H6.14187C4.20521 20.0231 3.004 17.9161 3.99058 16.2496L10.878 4.61541C11.8461 2.98017 14.2125 2.98017 15.1806 4.61541Z",
    fill: "#FFE735",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1277 14.1504L11.9177 7.54241H13.9477L13.7377 14.1504H12.1277ZM12.9397 17.4124C12.5943 17.4124 12.3097 17.3097 12.0857 17.1044C11.871 16.8897 11.7637 16.6284 11.7637 16.3204C11.7637 16.0124 11.871 15.7557 12.0857 15.5504C12.3097 15.3357 12.5943 15.2284 12.9397 15.2284C13.285 15.2284 13.565 15.3357 13.7797 15.5504C13.9943 15.7557 14.1017 16.0124 14.1017 16.3204C14.1017 16.6284 13.9943 16.8897 13.7797 17.1044C13.565 17.3097 13.285 17.4124 12.9397 17.4124Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.da7570f2ea27f5e99114b031bf4636e2.svg";
export { ForwardRef as ReactComponent };